function state() {
  return {
    token: null,
    allParticipants: [],
    pendingParticipantIds: [],
    settings: {},
  };
}

export default state;
